
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 141.7 138.9"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd"}},[_c('path',{attrs:{"d":"M102.8 137.9l38.8-48.8c1-2.2-8.1-38.5-9-42.6-1-4.7-2.2-9.4-3.2-14.2-.2-1-.5-2.5-.7-3.3-.9-3.2.4-1.4-1.9-2.9L73.4.6C69.8-1.1 68 1 61.9 3.9c-4.2 2-8 3.9-12.2 5.9L14.4 26.9c-1.5 1.6-3.1 11.3-3.8 14.4L.9 83.8C.1 87-.7 87.7.9 89.9l19.7 24.6c5.1 6.8 10.4 12.7 15.8 19.7 4.2 5.5 4.9 3.8 13.6 3.8 16.1 0 38 .6 52.8-.1z","fill":"#a20202"}}),_c('path',{attrs:{"fill":"#fefefe","d":"M94.5 110.1l-24-23.9-23.9 23.9-15.2-15.2L55.3 71 31.4 47l15.2-15.2 23.9 23.9 24-23.9L109.7 47 85.8 71l23.9 23.9z"}})])])
          )
        }
      }
    